
const setToWeekday = ( date, weekday ) => {
    // var day = date.getDay() || 7;  
    // if( day !== weekday ) date.setHours(-24 * (day - weekday)); 

    // switch(date.getDay()+1) {
    // switch(weekday) {
    //     case 1: return "Monday"
    //     case 2: return "Monday"
    //     case 3: return "Tuesday"
    //     case 4: return "Tuesday"
    //     case 5: return "Wednesday"
    //     case 6: return "Wednesday"
    //     case 7: return "Thursday"
    //     case 8: return "Thursday"
    //     case 9: return "Friday"
    //     case 10: return "Friday"
    //     case 11: return "Saturday"
    //     case 12: return "Saturday"
    // }
    switch(weekday) {
        case 1: return "Mon"
        case 2: return "Mon"
        case 3: return "Tue"
        case 4: return "Tue"
        case 5: return "Wed"
        case 6: return "Wed"
        case 7: return "Thu"
        case 8: return "Thu"
        case 9: return "Fri"
        case 10: return "Fri"
        case 11: return "Sat"
        case 12: return "Sat"
        default: return ""
    }
}

export default setToWeekday